import { render, staticRenderFns } from "./ConfirmPin.vue?vue&type=template&id=36e12ef1&scoped=true"
import script from "./ConfirmPin.vue?vue&type=script&lang=js"
export * from "./ConfirmPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e12ef1",
  null
  
)

export default component.exports